import React from 'react';
import VoxelDialog from '../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogActionButton from '../../../components/voxel/Dialogs/VoxelDialogActionButton';
import VoxelDialogActions from '../../../components/voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelText from '../../../components/voxel/Text/VoxelText';

export interface NewConnectionDialogCompleteProps {
  close: () => void;
  minWidth: string;
}

export const NewConnectionDialogComplete: React.FC<NewConnectionDialogCompleteProps> = ({
  close,
  minWidth,
}) => {
  return (
    <VoxelDialog open title="Connection invitation sent" onClose={close} closeOnBackdrop>
      <VoxelDialogContent classMinWidth={minWidth}>
        <VoxelText>An email has been sent with all the details</VoxelText>
      </VoxelDialogContent>
      <VoxelDialogActions>
        <VoxelDialogActionButton title="OK" onClick={close} color="primary" />
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default NewConnectionDialogComplete;
